<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>DERIVAR</h2></mat-dialog-content
>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>


<mat-dialog-content class="modal-body">
    <div class="content">
        <div class="block-content">
            <div class="form-horizontal">
                <div class="form-group">
                  <label class="col-md-3 control-label">Revisor (*):</label>
                  <div class="col-md-8">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                      <mat-label>
                        Seleccione
                      </mat-label>
                      <mat-select matSelect [(ngModel)]="data.idRevisor" name="idRevisor" required>
                        <mat-option *ngFor="let item of listaRevisores; index as i;" [value]='item.codigoUsuario'>{{ item.nombres + ' ' + item.apellidos}}</mat-option>
                      </mat-select>
                    </mat-form-field> 
                  </div>
                </div>
            </div>

            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-md-3 control-label">Comentarios (*):</label>
                <div class="col-md-8">
                  <mat-form-field class="example-full-width" appearance="outline" hideRequiredMarker>
                    <mat-label>Comentarios</mat-label>
                    <textarea
                      matInput
                      placeholder="Comentarios"
                      [(ngModel)]="data.comentarioPorDerivacion"
                      rows="5" [maxlength]="2000"
                      name="comentarioPorDerivacion" required
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
    <button type="submit" class="btn btn-celeste" mat-button (click)="enviar()"><mat-icon>group</mat-icon>Derivar</button>
    <!-- [mat-dialog-close]="data" -->
    <!-- <button class="btn btn-rojo2" mat-button [mat-dialog-close]="data" (click)="observar()">Observar</button> -->
    <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()">
      <mat-icon>exit_to_app</mat-icon> SALIR
    </button>
  </mat-dialog-actions>
</form>
  <!-- <pre>{{data | json}}</pre> -->